import type { FC, MouseEventHandler, PropsWithChildren } from 'react';
import React from 'react';

import type { IClassNameProps } from '@bem-react/core';

import { Icon as IconBase } from '../../Icon';
import { withCloseIcon } from '../../Icon/_glyph/Close';
import { compose } from '../../lib/compose';
import { cnTextarea } from '../Textarea.cn';

import './Textarea-Clear.css';

const IconClose = compose(withCloseIcon)(IconBase);

export interface ITextareaClearProps
    extends
        IClassNameProps,
        PropsWithChildren<{
            /**
             * Видимость крестика.
             */
            visible?: boolean;

            /**
             * Тема крестика.
             */
            theme?: string;

            /**
             * Внешний вид крестика.
             */
            view?: string;

            /**
             * Обработчик клика.
             */
            onClick?: MouseEventHandler<HTMLSpanElement>;

            /**
             * Обработчик события `onMouseDown`
             */
            onMouseDown?: MouseEventHandler<HTMLSpanElement>;
        }> {}

export const TextareaClear: FC<ITextareaClearProps> = ({ view, visible, children, ...props }) => {
    const className = cnTextarea('Clear', { visible }, [props.className]);

    return <IconClose {...props} glyph="close" sizeManagement="parent" className={className} />;
};
